<template>
  <v-card outlined rounded="xl" min-height="100%" class="d-flex flex-column">
    <v-card-title>
      <p v-if="active_place_hostel.name_room">Рассматриваемая комната: {{ active_place_hostel.name_room }}</p>
      <p v-else class="text-subtitle-1">Выберете комнату!</p>
    </v-card-title>

    <v-divider/>

    <v-data-table
      :headers="headers_table_res_state"
      :items="result_data_statements.data_statement"
      :search="search_table"
      :items-per-page="5"
      item-key="full_name"
      no-data-text="Данные отсутствуют"
      hide-default-footer
    >
      <template v-slot:item.statement_hostel.commission.dean_ex_work_confirm="{ item }">
        <v-chip
          small
          rounded
          elevation="0"
          :color="setStatus(item.statement_hostel.commission.dean_ex_work_confirm)"
          outlined
        >
          {{ setStatus(item.statement_hostel.commission.dean_ex_work_confirm) === 'green' ? 'Одобрено':
          'Рассматривается'}}
        </v-chip>
      </template>
      <template v-slot:item.person.privilege="{ item }">
        <v-icon
          @click="menu = true"
          v-if="item.person.privilege === 'Отсутствует'"
          size="20px"
        >
          fa-universal-access
        </v-icon>
        <v-icon
          @click="menu = true"
          v-else
          size="20px"
          color="green"
        >
          fa-universal-access
        </v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu
          rounded="lg"
          offset-y
          left
          origin="top right"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                size="15px"

              >
                fa-ellipsis-v
              </v-icon>
            </v-btn>
          </template>
          <v-list class="ma-0">
            <v-list-item
              v-for="(action_menu, index) in actions_menu" :key="index"
              @click="menuMethods(item, action_menu.type)"
              link
              dense
              class="px-0"
            >
              <v-list-item-avatar class="ma-0">
                <v-icon small :color="action_menu.color">
                  {{ action_menu.icon }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-title class="pr-2">{{ action_menu.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{item.created_at.length > 10 ? convertDate(item.created_at) : item.created_at}}
      </template>
    </v-data-table>
    <v-spacer/>
    <v-card-actions>
      <v-slide-x-transition>
        <div style="width: 100%" v-if="result_data_statements.data_request.length > 0">
          <v-progress-circular
            class="d-flex justify-center"
            v-if="status_conf"
            indeterminate
            color="teal"
          ></v-progress-circular>
          <v-btn
            v-else
            @click="confStatements()"
            color="teal darken-1"
            outlined
            rounded
            block
          >
            Заселить
          </v-btn>
        </div>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
    import _ from "lodash";

    export default {
        name: "CardPinning",
        props: {
            active_place_hostel: {
                type: Object
            }
        },
        data: () => ({
            menu: false,
            search_table: null,
            headers_table_res_state: [
                {text: 'ФИО', value: 'person.full_name', sortable: false},
                {text: 'РАУ', value: 'statement_hostel.rating', sortable: false, align: 'center'},
                {text: 'ПРИЗНАК', value: 'person.privilege', sortable: false, align: 'center'},
                {text: 'СТАТУС', value: 'statement_hostel.commissions.dean_ex_work_confirm', sortable: false, align: 'center'},
                {text: 'ДАТА ОТПРАВЛЕНИЯ', value: 'created_at', sortable: false},
                {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: 'center'},
            ],
            actions_menu: [
                { icon: "fa fa-times", color: "error", name: 'Выселение', type: 1 },
                { icon: "fa fa-share-square", color: "orange", name: 'Переселение',  type: 2 }
            ]
        }),
        mounted() {
        },
        computed: {
            ...mapState({
                result_data_statements: state => state.interactionStatement.result_data_statements,
                status_conf: state => state.interactionStatement.status_conf,
                list_statements: state => state.interactionStatement.list_statements,
                stm_applicants: state => state.interactionStatement.stm_applicants,
            }),
        },
        methods: {
            ...mapMutations({
                deleteResDataStates: 'interactionStatement/deleteResDataStates',
                setStatusConf: 'interactionStatement/setStatusConf',
                setResDataStates: 'interactionStatement/setResDataStates',
                setCountStatements: 'interactionStatement/setCountStatements',
            }),
            ...mapActions({
                ConfStatements: 'interactionStatement/ConfStatements',
                UnpinStatements: 'interactionStatement/UnpinStatements',
                GetDormFac: 'placesInDormitories/GetDormFac',
            }),
            menuMethods(item, type) {
                if (type === 1) {
                    this.deleteStates(item)
                }
                if (type === 2) {

                }
            },
            setStatus(conf) {
                if (conf === 1) {
                    return 'orange'
                } else if (conf === 2) {
                    return 'green'
                }
            },
            deleteStates(item) {
                if (item.statement_hostel.commission.dean_ex_work_confirm === 1){
                    this.deleteResDataStates(item)
                }
                else this.UnpinStatements(item.statement_hostel.id).then(
                    this.GetDormFac,
                    this.updateCurrentPlace(),
                    this.setCountStatements(this.list_statements.statement_hostels.length - _.intersectionBy(this.list_statements.statement_hostels, this.stm_applicants.stm_hostel_all, 'full_name').length))
            },
            convertDate(created_at) {
                const d = new Date(created_at)
                const day = d.getDate()
                const month = d.getMonth() + 1
                const year = d.getFullYear()
                return day + "-" + month + "-" + year
            },
            confStatements() {
                let res_data = []

                this.result_data_statements.data_statement.forEach(state => {
                    state.dean_ex_work_confirm = 2
                    let res_obj = {
                        name_hostel: this.active_place_hostel.name_hostel,
                        name_section: this.active_place_hostel.name_section,
                        name_room: this.active_place_hostel.name_room,
                    }
                    state.result_place = res_obj
                    res_data.push(state)
                })
                this.setResDataStates(res_data)
                this.setStatusConf(true)
                this.ConfStatements().then(this.GetDormFac, this.setCountStatements(this.list_statements.statement_hostels.length - _.intersectionBy(this.list_statements.statement_hostels, this.stm_applicants.stm_hostel_all, 'full_name').length))
            },
            updateCurrentPlace() {
                this.$emit('updateCurrentPlace', {
                    room_info_occupied: this.active_place_hostel.room_info.occupied - 1,
                })
            },
        }
    }
</script>

<style scoped>

</style>